

























import { Component, Vue } from 'vue-property-decorator'
import { USAGE_STAT_FEATURES } from '@/system/usage-stats'
import { TRACKMATCHING_METHODS } from '@/store/modules/trackmatching'

@Component({})
export default class PasteText extends Vue {
  text: string = this.$store.state.trackmatching.text
  modalOpen: boolean = false

  get disabled(): boolean {
    return !this.text
  }

  open() {
    this.modalOpen = true

    setTimeout(() => {
      if (!this.text) {
        (this.$refs as any).textarea.focus()
      }
    }, 50)
  }

  close() {
    this.modalOpen = false
  }

  clear() {
    this.text = ''
  }

  async confirm(e: KeyboardEvent) {
    if (this.disabled) return
    if (e && e.type === 'keydown' && !e.ctrlKey) return

    this.$store.commit('trackmatching/setMethod', TRACKMATCHING_METHODS.Text)
    this.$store.commit('trackmatching/setSeparator', null)
    this.$store.commit('trackmatching/setText', this.text) // Save to storage so it autofils when returning here
    this.$store.commit('trackmatching/parseText', this.text)
    this.$store.commit('trackmatching/setShowInputControls', true)

    await this.$router.push({
      name: 'trackmatching parsed'
    })

    window.addUsageStat(USAGE_STAT_FEATURES.TrackMatching, 'paste text')
  }

  created() {
    if (this.$store.state.auth.isDemoUser) {
      this.text = `Pretty Lights - Finally Moving
Daft Punk - Touch
Parov Stelar - Sunny Blues
- Prototypes`
    }
  }
}
